import APIClient from '@/apiClient'
import { useRoute, useRouter } from 'vue-router'
import moment from 'moment';

export const useUserStore = defineStore('user', () => {
  const route = useRoute()
  const router = useRouter()
  const apiClient = new APIClient()
  function checkPassword(password) {
    // Проверка длины пароля
    if (password.length < 8) {
        return false;
    }

    // Проверка наличия хотя бы одной строчной буквы
    if (!/[a-zа-я]/.test(password)) {
        return false;
    }

    // Проверка наличия хотя бы одной прописной буквы
    if (!/[A-ZА-Я]/.test(password)) {
        return false;
    }

    // Проверка наличия хотя бы одной цифры
    if (!/\d/.test(password)) {
        return false;
    }

    // Проверка наличия хотя бы одного специального символа
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)) {
        return false;
    }

    // Если все условия выполнены, возвращаем true
    return true;
}
  const call = async (type, method, params) => {
    let response = null
    try {
      if(user.value != null && typeof user.value.students !== 'undefined' && user.value.students.length > 1) {
        params['student_id'] = user.value.student.uuid
      }
    } catch(e) {
      console.log(e)
    }
    if (type.toLowerCase() == 'post')
      response = await apiClient.post(method, JSON.stringify(params), {'Content-Type': 'application/json'})
      if (type.toLowerCase() == 'put_form')
        response = await apiClient.put(method, params, {})
        if (type.toLowerCase() == 'post_form')
          response = await apiClient.post(method, params, {})
    if (type.toLowerCase() == 'put')
      response = await apiClient.put(method, JSON.stringify(params), {'Content-Type': 'application/json'})
    if (type.toLowerCase() == 'delete')
      response = await apiClient.delete(method, params)
    if (type.toLowerCase() == 'get')
      response = await apiClient.get(method, params)

    if (typeof response.error_code !== 'undefined') {
      throw response
    }

    return response
  }
  const token = ref(null)
  const isInited = ref(false)

  const isAuth = ref(false)
  const user = ref(null)

  const savedPersonGroup = ref(0)

  const forms = ref({
    register: {
      loading: false,
      errorMessage: null,
      errorState: false,
      successState: false,
      fields: {
        email: '',
        fullname: '',
        isAccept: false
      },
    },
    recovery: {
      loading: false,
      errorMessage: null,
      errorState: false,
      successState: false,
      fields: {
        email: '',
        fullname: '',
        isAccept: false
      },
    },
    confirm: {
      successState: false,
      errorState: false,
      errorMessage: null,
      confirmLoading: false,
      fields: {
        password: '',
        password2: '',
        hash: route.query.hash
      }
    },
    auth: {
      successState: false,
      errorState: false,
      errorMessage: null,
      confirmLoading: false,
      fields: {
        email: '',
        password: '',
      }
    }
  })
  
  const recovery = async () => {
    return new Promise(async (resolve) => {
      let form = forms.value.recovery
    if(form.loading) {
      resolve(0)
      return 0
    }
    form.errorState = false
    if (empty(form.fields.email) || empty(form.fields.fullname) || empty(form.fields.isAccept)) {
      form.errorState = true
      resolve(0)
      return 0
    }
    form.loading = true
    try {
      let response = await call('POST', 'user/recovery/', form.fields)
      if (typeof response.success !== 'undefined') {
        form.successState = true
        form.loading = false
        resolve(1)
        return 1
      }
    } catch (error) {
      form.errorMessage = error.error_message
    }
    resolve(0)
    form.loading = false
    })
  }
  const register = async (is_admin = false) => {
    return new Promise(async (resolve) => {
      let form = forms.value.register
    if(form.loading) {
      resolve(0)
      return 0
    }
    form.errorState = false
    if(form.fields.email.indexOf('@') == -1 || form.fields.fullname.indexOf('@') != -1) {
      form.errorMessage = 'Проверьте введенные данные'
      resolve(0)
      return 0
    }
    if (empty(form.fields.email) || empty(form.fields.fullname) || (is_admin == false && empty(form.fields.isAccept))) {
      form.errorState = true
      resolve(0)
      return 0
    }
    form.loading = true
    try {
      let fields = Object.assign({}, form.fields)

      if(is_admin) {
        fields.is_admin = 1
      }
      let response = await call('POST', 'user/register/', fields)
      if (typeof response.success !== 'undefined') {
        form.successState = true
        form.loading = false
        resolve(1)
        return 1
      }
    } catch (error) {
      form.errorMessage = error.error_message
    }
    resolve(0)
    form.loading = false
    })
  }
  const getCurrentStudyYear = (studyYear = null, startYear = null) => {
    if (startYear == null) {
      startYear = user.value.student.date_enrollment
    }
    if (studyYear == null) {
      studyYear = user.value.student.study_year
    }

    let studyYearString = ''
    let studyYearNumber = 0;
    switch (studyYear) {
      case "Первый":
        studyYearNumber = 1;
        break;
      case "Второй":
        studyYearNumber = 1;
        break;
      case "Третий":
        studyYearNumber = 2;
        break;
      case "Четвертый":
        studyYearNumber = 2;
        break;
      case "Пятый":
        studyYearNumber = 3;
        break;
      case "Шестой":
        studyYearNumber = 3
        break;
      case "Седьмой":
        studyYearNumber = 4;
        break;
      case "Восьмой":
        studyYearNumber = 4;
        break;
      case "Девятый":
        studyYearNumber = 5;
        break;
      case "Десятый":
        studyYearNumber = 6;
        break;
      // Добавьте другие кейсы по необходимости
    }
    const startDate = moment(startYear);
    const currentDate = moment();
    const yearEnd = startDate.add(studyYearNumber, 'years')
    const yearStart = yearEnd.clone().subtract(1, 'years')


    return moment(yearStart).format('yyyy') + ' - ' + moment(yearEnd).format('yyyy');
  }
  const auth = () => {
    return new Promise(async (resolve) => {
      let form = forms.value.auth
      if(form.loading) {
        resolve(0)
        return
      }
      form.errorState = false
  
      if (empty(form.fields.password) || empty(form.fields.email)) {
        form.errorState = true
        resolve(0)
        return
      }
      form.loading = true
      try {
        let response = await call('POST', 'user/auth/', form.fields)
        if (typeof response.success !== 'undefined' && typeof response.error_code === 'undefined') {
          setCookie('token', response.hash, 365)
          form.successState = true
          isInited.value = false
          loading()
          resolve(1)
          return
        }
      } catch (error) {
        console.log(error)
        form.errorMessage = error.error_message
      }
      form.loading = false
    })
  }

  const isPermission = (key) => {
    if(
      user.value == null || 
      user.value.account.person_groups[savedPersonGroup.value].person_group == null || 
      user.value.account.person_groups[savedPersonGroup.value].person_group.permissions == null
    ) return false;
    return user.value.account.person_groups[savedPersonGroup.value].person_group.permissions.find(o => o.entity.key == key) != null
  }
  const confirmRegister = () => {
    return new Promise(async (resolve) => {
      let form = forms.value.confirm
    form.errorMessage = null
    form.loading = true
    form.errorState = true
    if (empty(form.fields.password) || empty(form.fields.password2) || form.fields.password !== form.fields.password2 || !checkPassword(form.fields.password)) {
      form.loading = false
      return;
    }
    form.errorState = false
    form.fields.hash = route.query.hash
    try {
      let response = await call('POST', 'user/register/confirm/', form.fields)
      if (typeof response.success !== 'undefined') {
        form.successState = true
        form.errorState = false
        
          setCookie('token', response.hash, 365)
          form.successState = true
          isInited.value = false
          resolve(1)
          return

      }
    } catch (error) {
      form.errorMessage = error.error_message
    }
    resolve(0)
    form.loading = false
    })
  }
  const confirmRecovery = () => {
    return new Promise(async (resolve) => {
      let form = forms.value.confirm
    form.errorMessage = null
    form.loading = true
    form.errorState = true
    if (empty(form.fields.password) || empty(form.fields.password2) || form.fields.password !== form.fields.password2 || !checkPassword(form.fields.password)) {
      form.loading = false
      return;
    }
    form.errorState = false
    form.fields.hash = route.query.hash
    try {
      let response = await call('POST', 'user/recovery/confirm/', form.fields)
      if (typeof response.success !== 'undefined') {
        form.successState = true
        form.errorState = false
        
          setCookie('token', response.hash, 365)
          form.successState = true
          isInited.value = false
          resolve(1)
          return

      }
    } catch (error) {
      form.errorMessage = error.error_message
    }
    resolve(0)
    form.loading = false
    })
  }
  const empty = (val) => {
    return val == '' || val == null || val == false
  }

  const loading = async () => {
    if(route.path.indexOf('auth') !== -1) return;
    if (isInited.value) return;
    token.value = getCookie('token')
    isAuth.value = false

    if (token.value != null && getCookie('token') != '') {
      try {
        let response = await call('GET', 'user', {})
        if(typeof response.error_code !== 'undefined') {
          isAuth.value = false
          isInited.value = true
          return;
        }
        user.value = { ...response, token: token.value }
        user.value.is_diplom = false
        //
        if(user.value.account != null && user.value.account.length > 0) {
          user.value.account = user.value.account[0]
        }
        if(user.value.registry != null && user.value.registry.length > 0) {
          user.value.registry = user.value.registry[0]
        }
        if(user.value.staff != null && user.value.staff.length > 0) {
          user.value.staff = user.value.staff[0]
        }
        if(user.value.student != null && user.value.student.length > 0) {
            user.value.students = JSON.parse(JSON.stringify(user.value.student))
        }
        
        let _group = parseInt(localStorage.getItem('current_group'))
        savedPersonGroup.value = typeof user.value.account.person_groups[_group] === 'undefined' ? 0 : _group
        console.log('savedPersonGroup.value',savedPersonGroup.value)
        user.value.account.person_group = user.value.account.person_groups[savedPersonGroup.value].person_group
        if(user.value.students != null && user.value.students.length > 0)
        changeActiveStudent(null)
        //
        isAuth.value = true
        isInited.value = true
      } catch (e) {
        console.log(e)
        isInited.value = true
      }
      console.log(route.path)
      if(
        isAuth.value == false && 
        (
            (route.path.indexOf('/user/register') === -1 || route.path.indexOf('/user/recovery') === -1) && (
            route.path.indexOf('/user') !== -1 || 
            route.path.indexOf('/student') !== -1 || 
            route.path.indexOf('/staff') !== -1 || 
            route.path.indexOf('/teacher') !== -1)
          )
        ) {
       //s router.push('/auth');
        return;
      } else
      if(route.path.indexOf('auth') !== -1 && isAuth.value == true) {
        //router.push('/user')
        return;
      }
    }
  }
  
  const changeActivePersonGroup = (i) => {
    user.value.account.person_group = user.value.account.person_groups[i].person_group
    localStorage.setItem('current_group', i)
    savedPersonGroup.value = i 
  }
  const savedStudentUUID = ref(null)
  const changeActiveStudent = (i) => {
    console.log(i)
    if(i != null)
      localStorage.setItem('current_student', i)

    try {
      let student_uuid = localStorage.getItem('current_student')
      console.log('savedStudentUUID.value Before', savedStudentUUID.value)
      if(student_uuid == null) {
        user.value.student = user.value.students[0]
        savedStudentUUID.value = user.value.students[0]['uuid']
      } else {
        let flag = false
        for(let st of user.value.students) {
          if(student_uuid == st.uuid) {
            user.value.student = st
            savedStudentUUID.value = st.uuid
            flag = true
            console.log('user.value.student',user.value.student , savedStudentUUID.value)
            break
          }
        }

        if(flag == false) {
          localStorage.removeItem('current_student')
          user.value.student = user.value.students[0]
          savedStudentUUID.value = user.value.students[0]['uuid']
        }
      }
      console.log('savedStudentUUID.value after', savedStudentUUID.value)
      // user.value.student = user.value.student[0]
      let end_year = moment(user.value.student.worker_plan.academic_plan.plan.end_year).format('yyyy')
      let current_year = moment().format('yyyy')
      if(user.value.student.worker_plan.academic_plan.plan, moment(end_year).diff(current_year, 'years') <= 1) user.value.is_diplom = true
    } catch(e) {
      console.log(e)
    }
  }
  const logout = async () => {
    await call('GET', 'user/auth/logout', {})
    setCookie('token', '', 0)
    location.href = '/'
  }

  return {
    logout,
    call,
    forms,
    register,
    confirmRegister,
    confirmRecovery,savedStudentUUID,
    auth,
    loading,
    isAuth,
    user,
    token,
    getCurrentStudyYear,
    isPermission,
    isInited,
    changeActiveStudent,
    changeActivePersonGroup,savedPersonGroup,
    recovery
  }
})
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  // Добавляем параметры Secure и HttpOnly
  var secureFlag = window.location.protocol === "https:" ? "" : "";
  var cookieString = name + "=" + (value || "") + expires + "; path=/";
  document.cookie = cookieString;
}
function getCookie(cookieName) {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }

  return null; // Return null if the cookie with the specified name is not found
}